<template>
  <topbar
    :titulo="$t('FINANCEIRO_CONTAS_RECEBER.PAGE_TITLE')"
    :subtitulo="$t('FINANCEIRO_CONTAS_RECEBER.PAGE_DESCRIPTION')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4 gap-1">
        <div></div>
        <b-button variant="info" @click="cadastrar" v-if="podeCadastrar">
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO_LANCAMENTOS.PAGE_TITLE') },
        { titulo: this.$t('FINANCEIRO_CONTAS_RECEBER.PAGE_TITLE') },
      ],
    };
  },
  methods: {
    cadastrar() {
      this.$emit('cadastrar', 'novoLancamento');
    },
  },
};
</script>
